@if (!onlyIcon) {
  <div class="grid">
    <button type="button" (click)="openFilterDialog()" mat-stroked-button color="primary">
      <mat-icon>{{ ruleSet.rules.length ? 'settings' : 'add' }}</mat-icon>
      <mat-label>{{ 'COMMON.filter' | translate }}</mat-label>
    </button>
    @if (ruleSet.rules.length && withPreview) {
      <span
        class="preview-button"
        [mdePopoverTriggerFor]="preview"
        mdePopoverTriggerOn="click">
        {{ 'COMMON.preview' | translate }}
      </span>
    }
  </div>
} @else {
  <button type="button" (click)="openFilterDialog()"
    [matTooltip]="'COMMON.filter' | translate"
    mat-icon-button
    color="primary">
    @if (ruleSet.rules.length) {
      <mat-icon>filter_alt</mat-icon>
    }
    @if (!ruleSet.rules.length) {
      <mat-icon class="material-icons-outlined">filter_alt</mat-icon>
    }
  </button>
}

<mde-popover #preview="mdePopover" [mdePopoverCloseOnClick]="false" [mdePopoverOverlapTrigger]="false">
  <app-rule-view [rule]="ruleSet" [orderFieldMap]="orderFieldMap" border="true"></app-rule-view>
</mde-popover>
